import { render, staticRenderFns } from "./addCat.vue?vue&type=template&id=38238f40&scoped=true"
import script from "./addCat.vue?vue&type=script&lang=js"
export * from "./addCat.vue?vue&type=script&lang=js"
import style0 from "./addCat.vue?vue&type=style&index=0&id=38238f40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38238f40",
  null
  
)

export default component.exports